import { IOption } from "@/interfaces/IOption";
import { UserRole } from "@/interfaces/UserProfile";
import { PartialRecord } from "@/types/UtilityTypes";
export const MUI_LICENSE_KEY =
  "7e756af87f02c8c78a020d824c5000c3Tz0xMjk3MjIsRT0xODExNzIxNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y";

// Highcharts Core + Stock + Gantt v12.x - 20 Developer Annual Internal Licence.
// Contractual only (no runtime validation). Stored here for compliance tracking.
export const HIGHCHARTS_LICENSE_KEY = "FDE2-7C9D-6D0B-E7BD-A53F";

export const TITLE = {
  AppTitle: "LAMS",
  AdminTitle: "LAMS Administrator"
};

export const FILE_NAMES = {
  APP_BAR: "lams-logo.svg",
  HOME_BG: "bg.png",
  EMPTY_TRACK_COMMENT_BG: "undraw_add_tasks.svg",
  COMPANY_LOGO: "RT_Logo.svg",
  PERMIT_Map: "Interactive.png"
};

export const TENANCIES = ["RTA", "RTIO"];

export const MULTI_TENANCY = {
  HEADER: "x-tenancy",
  PARAMETER: "tenancy",
  STORAGE: "tenancy",
  DEFAULT: "RTIO"
};

export const EXTEND_BY_OPTIONS: IOption[] = [
  {
    id: "6",
    value: "6 months"
  },
  {
    id: "12",
    value: "1 year"
  },
  {
    id: "24",
    value: "2 year"
  },
  {
    id: "36",
    value: "3 year"
  },
  {
    id: "48",
    value: "4 year"
  },
  {
    id: "60",
    value: "5 year"
  }
];

export const ADDITIONAL_HEADER = {
  CLIENT_START_DATE: "x-client-start-date"
};

export const LAUNCHDARKLY_CLIENT_ID = import.meta.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || "";
export const READ_ONLY_MODE_LD_FLAG_NAME = "lamsReadOnly";
export const APP_UNAVAILABLE_MODE_LD_FLAG_NAME = "lamsUnavailable";
export const APP_UNAVAILABLE_MESSAGE_LD_FLAG_NAME = "lamsUnavailableMessage";
export const REASSIGNMENT_MODULE_LD_FLAG_NAME = "enableReassignmentModule";
export const SCHEDULED_TASK_PROCESSING_LD_FLAG_NAME = "scheduledTaskProcessing";

export enum ReturnRequestAcceptor {
  Requestor = 0,
  Coordinator = 1
}

export const ROLES_TOGGLES: PartialRecord<UserRole, string> = {
  [UserRole.Coordinator]: "Coordinator",
  [UserRole.TabOwner]: "SME",
  [UserRole.Endorser]: "Endorser"
};

export const ROLE_TOGGLE_PRIORITY_MAP: Record<UserRole, number> = {
  [UserRole.Coordinator]: 1,
  [UserRole.Endorser]: 2,
  [UserRole.TabOwner]: 3,
  [UserRole.Administrator]: 4,
  [UserRole.Guest]: 5,
  [UserRole.Requestor]: 6
};
